export default {
  LOADING_QUOTE: 'MARKETS_VIEW_TABLE_ROW_LOADING_QUOTE',
  LOADED_QUOTE: 'MARKETS_VIEW_TABLE_ROW_LOADED_QUOTE',
  PLACING_ORDER: 'MARKETS_VIEW_TABLE_ROW_PLACING_ORDER',
  PLACED_ORDER: 'MARKETS_VIEW_TABLE_ROW_PLACED_ORDER',
  DELETING_CONTRACT: 'MARKETS_VIEW_TABLE_ROW_DELETING_CONTRACT',
  DELETED_CONTRACT: 'MARKETS_VIEW_TABLE_ROW_DELETED_CONTRACT',
  SET_ORDER_QUANTITY: 'MARKETS_VIEW_TABLE_ROW_SET_QUANTITY',
};
